export const GET_HOLIDAYS = 'GET_HOLIDAYS';
